import { ROOT_JOURNAL_URL } from '@/shared/constants/urlConstants';
import { extractList } from '@/shared/utils/unwrapApiResponse';
import { logError, normalizeError } from '@/shared/lib/errors';
import type { IJournalArticle } from '@/entities/journal/model/types';

const ARTICLES_PER_PAGE = 8;

export const usePublications = () => {
  const { $journalService } = useNuxtApp();

  const link = ROOT_JOURNAL_URL;

  const { data: articles } = useAsyncData<IJournalArticle[]>(
    () => 'main-publications',
    async () => {
      try {
        return extractList<IJournalArticle>(
          await $journalService.getArticles<IJournalArticle[]>({
            page: 1,
            per_page: ARTICLES_PER_PAGE,
            by_group: 0,
            'sort-published_at': 'desc',
          }),
        );
      } catch (error) {
        logError(normalizeError(error), { action: 'main-publications' });
        return [];
      }
    },
    { default: () => [] },
  );

  return { articles, link };
};

export default usePublications;
